import { ModalMain } from "../styled";
import { FontGreyDarkMediumTitle } from "../../../../utils/typografyApp";
import SecondaryButton from "../../SecondaryButton";
import PrimaryButton from "../../PrimaryButton";
import { NewSection3DForm } from "./styled";
import Input from "../../Input";
import { useNewSection3DItemModalHook } from "./hook";
import { FormProvider } from "react-hook-form";

const NewSection3DModal = ({ onClose, selectedSection3DItem, asset3DItem }) => {

    const hook = useNewSection3DItemModalHook({ onClose, selectedSection3DItem, asset3DItem });
    console.log(hook.form.section3DItemForm.formState.errors)
    return (
        <ModalMain>
            <FormProvider {...hook.form.section3DItemForm}>
                <NewSection3DForm>
                    <form onSubmit={hook.form.section3DItemForm.handleSubmit(hook.form.onSubmit)}>
                        <div className={"menu-content"}>
                            <div className="content">
                                <div className="title">
                                    <FontGreyDarkMediumTitle>Cadastro de 3D da Seção</FontGreyDarkMediumTitle>
                                </div>
                                <div className="form-input">
                                    <Input type="text" placeholder="Nome do modelo de ativo" name="name" />
                                    <Input disabled={true} type="tag" placeholder="Tag do modelo" name="tag" className="tag" />
                                </div>
                            </div>

                            <div className="actions-container">
                                <SecondaryButton disabled={hook.form.isLoading} onClick={onClose}>Voltar</SecondaryButton>
                                <PrimaryButton disabled={hook.form.isLoading} type={'submit'}> {hook.form.isLoading ? 'Salvando...' : selectedSection3DItem ? 'Editar' : 'Criar'} </PrimaryButton>
                            </div>
                        </div>
                    </form>
                </NewSection3DForm>
            </FormProvider>
        </ModalMain>
    );
}

export default NewSection3DModal;